import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2524">
      <Navbar data-id="element-2525" />
      <main data-id="element-2526">
        <ConsularAffairs data-id="element-2527" />
      </main>
      <Footer data-id="element-2528" />
      <FeedbackPopup data-id="element-2529" />
    </div>;
}